export default __webpack_public_path__ + "static/media/image-2.4e193fd0.png";